const accordions = {
	init: () => {
		const accordions = document.querySelectorAll('.accordion-item');
		if (!accordions) return;

		accordions.forEach(accordion => {
			const btn = accordion.querySelector('button');
			const content = accordion.querySelector('.accordion');

			if (!btn || !content) return;

			accordion.addEventListener('click', () => {
				const expanded = btn?.getAttribute('aria-expanded') === 'true';
				btn?.setAttribute('aria-expanded', expanded ? 'false' : 'true');

				if (expanded) {
					content?.removeAttribute('hidden');
				} else {
					content?.setAttribute('hidden', 'true');
				}
			});

		});
	},
};

export default accordions;
